import { CSSProperties } from 'react';

export const cardTitle: CSSProperties = {
  fontSize: 'var(--font-size-title)',
  fontWeight: 'bold',
};
